const methodsHttps = {
    __POST__: 'POST',
    __GET__: 'GET',
}
const url = {
    cart: '/cart',
    checkout: '/checkout'
}

const $btnsAdd = document.querySelectorAll('.btn_add')
const $btnsShop = document.querySelectorAll('.btn_shop')

async function addToCart(id, url) {
    const formData = {
        'items': [{
            'id': id,
            'quantity': 1
        }]
    };

    try {
        await fetch('/cart/add.js', {
            method: methodsHttps.__POST__,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        }).then(() => window.location.href = url)
    } catch (e) {
        console.error(e)
    }

}

$btnsAdd.forEach(btn => {
    btn.addEventListener('click', () => addToCart(btn.dataset.id, url.cart))
})

$btnsShop.forEach(btn => {
    btn.addEventListener('click', () => addToCart(btn.dataset.id, url.checkout))
})

